module.exports = __webpack_public_path__ + "img/2012-08-18 13.25.52.261583cc.jpg";